import { render } from "./Hotspot.vue?vue&type=template&id=1c761d13"
import script from "./Hotspot.vue?vue&type=script&lang=js"
export * from "./Hotspot.vue?vue&type=script&lang=js"

import "./Hotspot.vue?vue&type=style&index=0&id=1c761d13&lang=scss"

import exportComponent from "D:\\code\\newspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__